(() => {
  if (customElements.get('harvest-promo')) return;
  class HarvestPromo extends HTMLElement {
    connectedCallback() {
      if (this.dataset.initialized) return;
      const nav = this.querySelector('[data-hmp-tabs]');
      const tabs = Array.from(this.querySelectorAll('[data-hmp-tab]'));
      const panels = Array.from(this.querySelectorAll('[data-hmp-panel]'));
      if (!nav || tabs.length !== panels.length || !tabs.length) return;
      const prefix = this.id;
      if (!prefix || tabs.some(tab => !panels.find(panel => panel.dataset.hmpPanel === tab.dataset.hmpTab))) return;
      this.dataset.initialized = 'true';
      const activate = (index, moveFocus = false) => {
        tabs.forEach((tab, i) => {
          const active = i === index;
          tab.setAttribute('aria-selected', String(active));
          tab.tabIndex = active ? 0 : -1;
          panels.find(panel => panel.dataset.hmpPanel === tab.dataset.hmpTab).hidden = !active;
        });
        if (moveFocus) tabs[index].focus({ preventScroll: true });
      };
      nav.setAttribute('role', 'tablist');
      tabs.forEach((tab, index) => {
        const key = tab.dataset.hmpTab;
        const panel = panels.find(item => item.dataset.hmpPanel === key);
        tab.id = `${prefix}-tab-${key}`;
        tab.setAttribute('role', 'tab');
        tab.setAttribute('aria-controls', `${prefix}-panel-${key}`);
        panel.id = `${prefix}-panel-${key}`;
        panel.setAttribute('role', 'tabpanel');
        panel.setAttribute('aria-labelledby', tab.id);
        panel.tabIndex = 0;
        tab.addEventListener('click', () => activate(index));
        tab.addEventListener('keydown', event => {
          let next;
          if (event.key === 'ArrowRight') next = (index + 1) % tabs.length;
          else if (event.key === 'ArrowLeft') next = (index - 1 + tabs.length) % tabs.length;
          else if (event.key === 'Home') next = 0;
          else if (event.key === 'End') next = tabs.length - 1;
          if (next !== undefined) { event.preventDefault(); activate(next, true); }
        });
      });
      activate(0);
      this.classList.add('hmp-enhanced');
      nav.hidden = false;
    }
  }
  customElements.define('harvest-promo', HarvestPromo);
})();
(() => {
  const root = document.querySelector('[data-private-review]');
  if (!root || root.dataset.initialized) return;
  root.dataset.initialized = 'true';
  const gate = root.querySelector('.hm-private-gate');
  const form = root.querySelector('form');
  const input = root.querySelector('input');
  const submit = form.querySelector('button');
  const status = root.querySelector('[role="status"]');
  const content = root.querySelector('.hm-private-content');
  const toolbar = root.querySelector('.hm-private-tools');
  const encoder = new TextEncoder();
  const aad = 'harvestmarket:our-difference:2026-09-09-company-growth';
  let generation = 0;
  let controller;
  let busy = false;
  const decode = value => Uint8Array.from(atob(value), character => character.charCodeAt(0));
  const lock = (focus = true) => {
    generation += 1;
    controller?.abort();
    content.replaceChildren();
    toolbar.hidden = true;
    gate.hidden = false;
    input.value = '';
    busy = false;
    submit.disabled = !window.crypto?.subtle;
    submit.textContent = 'Unlock page';
    status.textContent = '';
    if (focus) input.focus();
  };
  form.addEventListener('submit', async event => {
    event.preventDefault();
    event.stopPropagation();
    if (busy || !window.crypto?.subtle) return;
    busy = true;
    submit.disabled = true;
    submit.textContent = 'Unlocking…';
    status.textContent = 'Checking password…';
    const attempt = ++generation;
    let password = input.value;
    input.value = '';
    let stage = 'loading';
    let timer;
    try {
      controller = new AbortController();
      timer = setTimeout(() => controller.abort(), 20000);
      const response = await fetch(root.dataset.payloadUrl, { signal: controller.signal, credentials: 'omit' });
      if (!response.ok) throw new Error('Unavailable content');
      const payload = await response.json();
      if (payload.version !== 1 || payload.algorithm !== 'AES-256-GCM' || payload.kdf !== 'PBKDF2-SHA256' || payload.iterations !== 600000 || payload.aad !== aad || typeof payload.ciphertext !== 'string' || payload.ciphertext.length > 250000) throw new Error('Unsupported content');
      const salt = decode(payload.salt);
      const iv = decode(payload.iv);
      if (salt.length !== 16 || iv.length !== 12) throw new Error('Invalid content');
      stage = 'password';
      const material = await crypto.subtle.importKey('raw', encoder.encode(password), 'PBKDF2', false, ['deriveKey']);
      password = '';
      const key = await crypto.subtle.deriveKey({ name: 'PBKDF2', salt, iterations: payload.iterations, hash: 'SHA-256' }, material, { name: 'AES-GCM', length: 256 }, false, ['decrypt']);
      const decrypted = await crypto.subtle.decrypt({ name: 'AES-GCM', iv, additionalData: encoder.encode(aad), tagLength: 128 }, key, decode(payload.ciphertext));
      if (attempt !== generation) return;
      stage = 'rendering';
      const fragment = document.createElement('template');
      fragment.innerHTML = new TextDecoder().decode(decrypted);
      new Uint8Array(decrypted).fill(0);
      if (!fragment.content.querySelector('harvest-promo') || fragment.content.querySelector('script')) throw new Error('Invalid page');
      content.replaceChildren(fragment.content);
      gate.hidden = true;
      toolbar.hidden = false;
      const heading = content.querySelector('h1');
      heading.tabIndex = -1;
      heading.focus({ preventScroll: true });
      const anchor = document.getElementById(location.hash.slice(1));
      if (anchor && content.contains(anchor)) anchor.scrollIntoView();
    } catch {
      if (attempt !== generation) return;
      content.replaceChildren();
      status.textContent = stage === 'password' ? 'That password did not unlock the page. Please try again.' : 'The protected page could not be loaded. Please try again.';
      input.focus();
    } finally {
      password = '';
      clearTimeout(timer);
      if (attempt === generation) {
        busy = false;
        submit.disabled = false;
        submit.textContent = 'Unlock page';
      }
    }
  });
  root.querySelector('.hm-private-lock').addEventListener('click', () => lock());
  window.addEventListener('pagehide', () => lock(false));
  window.addEventListener('pageshow', event => { if (event.persisted) lock(false); });
  if (window.crypto?.subtle) {
    submit.disabled = false;
    status.textContent = 'The page locks again when you reload or leave.';
  } else {
    status.textContent = 'This browser cannot decrypt the page. Please use an up-to-date browser over HTTPS.';
  }
})();
